import { centralizedApiCalling, validateToken } from "./centralizedApiCalling";
import { getToken } from "./tokenStore";
const backendApi = process.env.REACT_APP_BACKEND_API_URL;
const versionCheckApi = process.env.REACT_APP_VERSION_CHECK_CLIENTS;
const includeToken = true;
const skipValidation = true;



// export const importMerchantFiles = async (body) => {

//     const response = await centralizedApiCalling(`${backendApi}/extraction/import_merchant_files`, "POST", body, includeToken, skipValidation);
//     console.log("response",response)
//      return response.data;
// };

export const importMerchantFiles = async (body) => {

    const response = await centralizedApiCalling(`${backendApi}/extraction/import_merchant_files`, "POST", body, includeToken, skipValidation);

    return response;
};
export const getreconciliationData = async (body) => {

    const response = await centralizedApiCalling(`${backendApi}/API/reconciliation_summary`, "GET", body, includeToken, skipValidation);
    return response.data;
};
export const reconciliationDetails = async (body) => {

    const response = await centralizedApiCalling(`${backendApi}/API/reconciliation_details`, "GET", body, includeToken, skipValidation);
    return response.data;
};

export const getUserConfig = async (corporation_id, user_id) => {

    const body = { corporation_id, user_id }
    const response = await centralizedApiCalling(`${backendApi}/API/user_config`, "POST", body, includeToken, skipValidation);
    return response;

};
export const getChargebacks = async (body) => {

    const response = await centralizedApiCalling(`${backendApi}/API/get_chargebacks`, "POST", body, includeToken, skipValidation);
    return response.data;

};

export const chargebackReset = async (body) => {
    const response = await centralizedApiCalling(`${backendApi}/API/chargeback_reset`, "PUT", body, includeToken, skipValidation);
    return response.data;

};
export const getReversedAndResponded = async (url, body) => {

    const response = await centralizedApiCalling(`${backendApi}/API/${url}`, "PUT", body, includeToken, skipValidation);
    return response.data;
};

export const chargebackIrreversible = async (url, body) => {
    const response = await centralizedApiCalling(`${backendApi}/API/${url}`, "PUT", body, includeToken, skipValidation);
    return response.data;

};

export const fetchUndoImport = async (body) => {

    const response = await centralizedApiCalling(`${backendApi}/API/undo_import/`, "PUT", body, includeToken, skipValidation);
    return response.data;
};


export const manualReconcile = async (body) => {

    const response = await centralizedApiCalling(`${backendApi}/reconciliation/manual_reconcile`, "POST", body, includeToken, skipValidation);
    if (!response.success) {
        throw response;
    }
    return response.data;

};

export const getChargeBacksTabsValues = async (body) => {

    const response = await centralizedApiCalling(`${backendApi}/API/chargebacks_tabs`, "GET", body, includeToken, skipValidation);
    return response.data;
};
// export const dsCardTabValues = async (body) => {

//     const response = await centralizedApiCalling(`${backendApi}/API/dscards_tabs`, "GET", body, includeToken, skipValidation);
//     return response.data;
// };

export const merchantSummary = async (body) => {
    const data = await centralizedApiCalling(`${backendApi}/widget/merchant_summary`, "GET", body, includeToken, skipValidation);
    return data.data;
};

export const getSummaryViewGrid = async (body) => {
    const data = await centralizedApiCalling(`${backendApi}/widget/get_summary_view_grid`, "GET", body, includeToken, skipValidation);
    return data.data;
};

export const getTrancDetails = async (body) => {

    const response = await centralizedApiCalling(`${backendApi}/widget/get_trans_details`, "POST", body, includeToken, skipValidation);
    return response.data;

};
export const chargeBacksPie = async (body) => {
    const data = await centralizedApiCalling(`${backendApi}/widget/chargeback-pie`, "GET", body, includeToken, skipValidation);
    return data.data;
};
export const pendingBarGraph = async (body) => {
    const data = await centralizedApiCalling(`${backendApi}/widget/pending-bar-graph`, "GET", body, includeToken, skipValidation);
    return data.data;
};



export const updateSalesData = async (body) => {
    const data = await centralizedApiCalling(`${backendApi}/API/update_sales_data`, "PUT", body, includeToken, skipValidation);
    return data.data;
};
export const fileStatus = async (id) => {
    const data = await centralizedApiCalling(`${backendApi}/API/update_file_status?recon_id=${id}`, "POST", includeToken, skipValidation);
    return data;
};
export const merchatCorpDetais = async (body) => {
    const data = await centralizedApiCalling(`${backendApi}/widget/fetch_corp_details`, "GET", body, includeToken, skipValidation);
    return data?.data;
};

export const handleExportFile = async (url, body) => {

    const token = await getToken();
    const isValid = await validateToken(token);
    if (!isValid) {
        throw new Error("Session expired");
    }

    const res = await fetch(`${backendApi}/widget/${url}`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
    });

    if (!res.ok) {
        const err = await res.json();
        throw new Error(err?.message || "Export failed");
    }

    const blob = await res.blob();

    return {
        blob,
        headers: res.headers,
    };
};

export const v2Clients = async () => {
    const data = await centralizedApiCalling(`${versionCheckApi}/v2_clients`, "GET", null, includeToken, false);
    return data?.data;
};
